import { ButtonPrimeReact } from "@finanedi.es/storybook"
// @ts-expect-error TS(2307): Cannot find module 'assets/plantillas_excel/planti...
import plantillaProductos from "assets/plantillas_excel/plantilla_importar_productos.xlsx"
import CustomButton from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import ImportGrid from "common/components/ImportGrid"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import useImportGrid from "common/hooks/useImportGrid"
import notification from "common/utils/notification"
import ArticuloService from "features/Inventario/services/ArticuloService"
import { checkDocumentFormat } from "features/User/utils"
import { Message } from "primereact/message"
import { useTranslation } from "react-i18next"

const options = [
  { label: "No importar", value: "" },
  { label: "Concepto", value: "concepto" },
  { label: "Referencia", value: "numeroReferencia" },
  { label: "Precio de venta", value: "precioVenta" },
]

const ImportarProductos = () => {
  const { t } = useTranslation()
  const {
    header,
    setData,
    data,
    handleSetData,
    selectedOptions,
    setSelectedOptions,
    handleUpload,
    fetching,
  } = useImportGrid({ options })

  const { handleDownloadFile } = useDownloadFileContext()

  const handleOnDrop = async (files: $TSMigrationFixMe) => {
    checkDocumentFormat(files?.length, files[0], handleSetData)
  }

  const handleImportarArticulos = async () => {
    const ok = await handleUpload(ArticuloService.postMany)
    if (ok) {
      notification.success({
        body: `${t("importar.productos.msg.correctImport")}`,
      })
    }
  }

  const handleDownloadPlantilla = () => {
    handleDownloadFile(plantillaProductos, "plantilla_productos.xlsx")
  }

  return (
    <div className='d-flex- justify-content-center h-100 import-scroller-page'>
      <p
        className='text-left text-gedesco'
        style={{ fontSize: "21px" }}
      >
        {t("importar.productos.title")}
      </p>

      <div className='mb-3 d-flex justify-content-between'>
        <Message
          className='w-75'
          severity='info'
          text={`${t("importar.productos.msgTemplate")}`}
        />
        <CustomButton
          className='!tw-bg-primary'
          onClick={handleDownloadPlantilla}
        >
          {t("importar.productos.downloadTemplate")}
        </CustomButton>
      </div>

      <Dropzone
        maxFiles={1}
        onDrop={handleOnDrop}
        accept='.xlsx'
        acceptLabel='.xlsx'
        fluid
      />

      <ImportGrid
        data={data}
        setData={setData}
        header={header}
        options={options}
        dropdownStates={selectedOptions}
        setDropdownStates={setSelectedOptions}
        maxFiles={5}
      />

      <div className='my-3 mr-1 d-flex justify-content-end'>
        {data.length ? (
          <ButtonPrimeReact
            loading={fetching}
            onClick={handleImportarArticulos}
            className='!tw-bg-primary !tw-border-none tw-text-simple-10'
          >
            {t("importar.productos.importButton")}
          </ButtonPrimeReact>
        ) : null}
      </div>
    </div>
  )
}

export default ImportarProductos
